import {DateTime} from "luxon";
import {Interval} from "../../../pages/Insights/View/VisitorDensity";
import {VisitorDensityInterval} from "./VisitorsDensityTimelineMap.types";

type GetIntervalsParams = { since?: DateTime, until?: DateTime, locale?: string, interval?: Interval }

export function getIntervals({since, until, locale = 'en-GB', interval = '30-mins'}: GetIntervalsParams) {
  if (!since || !until) return;

  const intervalDurations: Record<Interval, Record<string, number>> = {
    '30-mins': { minute: 30 },
    '1-hour': { hour: 1 },
    '2-hours': { hour: 2 },
    '3-hours': { hour: 3 },
    '4-hours': { hour: 4 },
    '6-hours': { hour: 6 },
    '12-hours': { hour: 12 },
    '24-hours': { hour: 24 },
  }

  let start = since;
  const end = until;

  let intervals: VisitorDensityInterval[] = [];
  const durationConfig = intervalDurations[interval];

  function getLabelText() {
    const is24HoursDuration = interval === '24-hours';
    const date = start.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY, {locale});
    const startTime = start.toLocaleString(DateTime.TIME_SIMPLE, {locale});
    const endTime = start.plus(durationConfig).toLocaleString(DateTime.TIME_SIMPLE, {locale})

    return `${date} ${is24HoursDuration ? '' : `(${startTime} to ${endTime})`}`
  }

  while (start < end) {
    intervals.push({
      label: getLabelText(),
      start: start.toMillis(),
      end: start.plus(durationConfig).toMillis(),
    })

    start = start.plus(durationConfig);
  }

  return intervals;
}